import request from './request'

/**
 * 创建引入人
 * @param {object} data - 创建引入人请求
 * @param {string} data.name - 引入人姓名
 * @param {string} data.phone - 联系电话
 * @param {string} [data.wechat] - 微信号
 * @param {string} [data.referrerType] - 引入类型: 0-渠道, 1-客户转介绍, 2-政府, 3-其他
 * @param {string} [data.remark] - 备注
 */
export function createReferrer(data) {
  return request.post('/referrer', data)
}

/**
 * 更新引入人
 * @param {object} data - 更新引入人请求
 * @param {number} data.id - 引入人ID
 * @param {string} data.name - 引入人姓名
 * @param {string} data.phone - 联系电话
 * @param {string} [data.wechat] - 微信号
 * @param {string} [data.referrerType] - 引入类型: 0-渠道, 1-客户转介绍, 2-政府, 3-其他
 * @param {string} [data.remark] - 备注
 */
export function updateReferrer(data) {
  return request.put('/referrer', data)
}

/**
 * 修改引入人状态
 * @param {number} id - 引入人ID
 * @param {number} status - 状态（0-禁用，1-启用）
 */
export function updateReferrerStatus(id, status) {
  return request.put(`/referrer/${id}/status`, null, { params: { status } })
}

/**
 * 分页查询引入人
 * @param {object} data - 查询参数
 * @param {number} [data.id] - 引入人ID
 * @param {string} [data.name] - 引入人姓名
 * @param {string} [data.phone] - 联系电话
 * @param {string} [data.referrerType] - 引入类型
 * @param {number} [data.status] - 状态
 * @param {number} [data.page] - 当前页
 * @param {number} [data.size] - 每页大小
 */
export function getReferrerPage(data) {
  return request.post('/referrer/page', data)
}

/**
 * 根据ID获取引入人详情
 * @param {number} id - 引入人ID
 */
export function getReferrerById(id) {
  return request.get(`/referrer/${id}`)
}

/**
 * 删除引入人
 * @param {number} id - 引入人ID
 */
export function deleteReferrer(id) {
  return request.delete(`/referrer/${id}`)
}

/**
 * 根据APP用户手机号绑定引入人与APP用户
 * @param {number} id - 引入人ID
 * @param {object} data - 绑定请求
 * @param {number} data.referrerId - 引入人ID
 * @param {string} data.phone - APP用户手机号
 */
export function bindAppUser(id, data) {
  return request.post(`/referrer/${id}/bind-app-user`, data)
}

/**
 * 获取引入人绑定的APP用户信息
 * @param {number} id - 引入人ID
 */
export function getReferrerAppUser(id) {
  return request.get(`/referrer/${id}/app-user`)
}

/**
 * 查询引入人手机号匹配的未绑定APP用户
 * @param {number} id - 引入人ID
 */
export function getReferrerAppUserCandidate(id) {
  return request.get(`/referrer/${id}/app-user/candidate`)
}

/**
 * 快速绑定引入人手机号匹配的未绑定APP用户
 * @param {number} id - 引入人ID
 */
export function bindReferrerAppUserCandidate(id) {
  return request.post(`/referrer/${id}/bind-app-user/candidate`)
}

/**
 * 解除引入人与APP用户绑定
 * @param {number} id - 引入人ID
 */
export function unbindAppUser(id) {
  return request.delete(`/referrer/${id}/app-user`)
}
